import React from 'react';
export const AnalyticsContext = React.createContext();
